import { Component, Input } from '@angular/core';
import {
    NavController,
    NavParams
} from 'ionic-angular';
import { ApiService } from '../../../../services/api';
import { Rodeo } from '../../../../model/rodeo';
import { Sidepot } from '../../../../model/sidepot';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { EntryCostGenerator } from '../../../../lib/entryCostGenerator';
import { PriceTier } from '../../../../model/price-tier.model';
import { ChangeRequestHelper } from '../../../../model/registration-change-request';

@Component({
    selector: 'page-summary-report',
    templateUrl: 'report-summary.html'

})
export class SummaryReport {
    @Input('rodeo') rodeo: Rodeo
   

    documentTitle: any;
    popoverActive: boolean;
    dataLoaded: boolean;
    printing: boolean;

    payoutPercentage: number[];
    payoutPercentageSidepot: any[];

    winnerTotals: any[];
    profits: any[];
    stockCosts: any[];
    notifiedTurnouts: any[];
    rodeoEventMap: any[];
    sidepotMap: any[];
    exhibitionMap: any[];
    expenseSummaries: any[] = [];

    entryCostGenerator: EntryCostGenerator = EntryCostGenerator.instance();

    constructor(private nav: NavController, navParams: NavParams, public api: ApiService) {
        if (!this.rodeo)
            this.rodeo = navParams.get('rodeo');
            
        this.payoutPercentage = navParams.get('payoutPercentage');

        this.printing = navParams.get('printing');

        setTimeout(() => {
            this.load();
        }, 0);
    }

    load() {
        this.payoutPercentage = [];
        this.payoutPercentageSidepot = [];
        this.rodeoEventMap = [];
        this.sidepotMap = [];
        this.exhibitionMap = [];
        this.winnerTotals = [];
        this.profits = [];
        this.stockCosts = [];
        this.notifiedTurnouts = [];
        this.expenseSummaries = [];

        let index = 0;
        this.rodeo.rodeoEvents.forEach((rodeoEvent) => {
            this.payoutPercentage.push(80);
            this.payoutPercentageSidepot.push([]);
            rodeoEvent.sidepots.forEach((sidepot) => {
                this.payoutPercentageSidepot[index].push(80);
            });

            this.rodeoEventMap[rodeoEvent.id] = rodeoEvent;

            rodeoEvent.sidepots.forEach((sidepot) => {
                this.sidepotMap[sidepot.id] = sidepot;
            })

            this.winnerTotals[rodeoEvent.id] = {};
            this.winnerTotals[rodeoEvent.id].all = rodeoEvent.winners.reduce((acc, winner) => { return acc + winner.payout; }, 0);

            var sidepotPayoutConfigs = this.rodeo.payoutConfigs.filter(x => x.sources.find(y => !y.sidepotId) != null);

            this.winnerTotals[rodeoEvent.id].main = rodeoEvent.winners.filter(x => sidepotPayoutConfigs.find(y => y.id == x.payoutConfigId) != null).reduce((acc, winner) => { return acc + winner.payout; }, 0);
            this.winnerTotals[rodeoEvent.id].sidepots = [];

            (rodeoEvent as any).addStockCost = true;
            this.stockCosts[rodeoEvent.id] = rodeoEvent.schedules.flatMap(x => x.runs).filter(x => x.done && !(x.turnedOut)).length * rodeoEvent.stockFee;
            this.notifiedTurnouts[rodeoEvent.id] = rodeoEvent.registrations.flatMap(x => x.changeRequests).filter(x => ChangeRequestHelper.isMoneyOutOfPot(x)).length;

            
            if (rodeoEvent.priceTiers.length == 0)
                rodeoEvent.priceTiers[0] = { unitPrice: 0} as PriceTier;

            this.profits[rodeoEvent.id] = {};
            this.profits[rodeoEvent.id].all = rodeoEvent.priceTiers[0].unitPrice * this.getRegistrationCount(rodeoEvent, false) - this.stockCosts[rodeoEvent.id] - this.winnerTotals[rodeoEvent.id].all;
            this.profits[rodeoEvent.id].main = rodeoEvent.priceTiers[0].unitPrice * this.getRegistrationCount(rodeoEvent, false) - this.stockCosts[rodeoEvent.id] - this.winnerTotals[rodeoEvent.id].main;
            this.profits[rodeoEvent.id].sidepots = [];

            rodeoEvent.sidepots.forEach((sidepot) => {
                this.winnerTotals[rodeoEvent.id].sidepots[sidepot.id] = 0;

                var payoutConfigs = this.rodeo.payoutConfigs.filter(x => x.sources.find(y => y.sidepotId == sidepot.id) != null);

                if (payoutConfigs.length == 0)
                    return;

                this.winnerTotals[rodeoEvent.id].sidepots[sidepot.id] = rodeoEvent.winners.filter(x => payoutConfigs.find(y => y.id == x.payoutConfigId)).reduce((acc, winner) => { return acc + winner.payout; }, 0);
                this.profits[rodeoEvent.id].sidepots[sidepot.id] = sidepot.cost * this.getSidepotCount(rodeoEvent, sidepot) - this.winnerTotals[rodeoEvent.id].sidepots[sidepot.id];
                this.profits[rodeoEvent.id].all += sidepot.cost * this.getSidepotCount(rodeoEvent, sidepot);
            })

            index++;
        });

        this.rodeo.exhibitions.forEach((exhibition) => {
            this.exhibitionMap[exhibition.id] = exhibition;
        })

        this.entryCostGenerator.reloadEntryInfo(this.rodeo, null);
        this.calculateExpenseSummaries();

        this.documentTitle = this.rodeo.name + " - " + 'Entries';
        this.dataLoaded = true;
    }

    getRegistrationCount(rodeoEvent, includeLateFees) {
        return includeLateFees ? rodeoEvent.registrations.filter(x => x.lateFee).length + this.getCarryOverCount(rodeoEvent, true) : rodeoEvent.registrations.length - this.notifiedTurnouts[rodeoEvent.id] + this.getCarryOverCount(rodeoEvent, false)
    }

    getCarryOverCount(rodeoEvent, includeLateFees) {
        if (!rodeoEvent.carryOverCount) {
            let regCount = 0;
            let lateRegCount = 0;

            this.rodeo.rodeoEvents.filter(x => x.carryOvers.some(y => y.carryOverId == rodeoEvent.id)).forEach((carryFromEvent) => {
                carryFromEvent.registrations.filter(x => x.carryOvers.some(y => y.rodeoEventId == rodeoEvent.id)).forEach((carryOverRegistration) => {
                    regCount++;
                    lateRegCount += carryOverRegistration.carryOvers.filter(x => x.rodeoEventId == rodeoEvent.id && x.lateFee === true).length;
                });
            });

            rodeoEvent.carryOverCount = regCount;
            rodeoEvent.carryOverLateCount = lateRegCount;
        }

        return includeLateFees ? rodeoEvent.carryOverLateCount : rodeoEvent.carryOverCount;
    }

    getExhibitionCount() {
        return this.rodeo.rodeoEvents.flatMap(x => x.registrations).flatMap(x => x.exhibitions).map(x => x.entryCount).reduce((sum, current) => sum + current, 0);
    }

    getExhibitionCost() {
        return this.rodeo.exhibitions.length > 0 ? this.rodeo.exhibitions[0].cost : 0;
    }

    getSidepotCount(rodeoEvent: RodeoEvent, sidepot: Sidepot) {
        return this.rodeo.rodeoEvents.flatMap(x => x.registrations).filter(x => x.sidepotIds.some(y => y == sidepot.id)).length;
    }

    getNextGenEntryFeeCount() {
        return 0;
    }

    getOfficeFeeCount() {
        // Setting for calculating office on secretary? event? Org?
        let perHorse = false;
        if (perHorse)
            return new Set(this.rodeo.rodeoEvents.filter(x => x.priceTiers[0].unitPrice > 0).flatMap(x => x.registrations).flatMap(x => x.horseOneId)).size;
        else
            return this.getUniqueEnterContestantCount(false);
    }

    getLateFeeCount() {
        // Setting for calculating office on secretary? event? Org?
        let perHorse = false;
        if (perHorse)
            return new Set(this.rodeo.rodeoEvents.filter(x => x.priceTiers[0].unitPrice > 0).flatMap(x => x.registrations.filter(x => x.created > this.rodeo.lateRegistrationStartDate)).flatMap(x => x.horseOneId)).size;
        else
            return this.getUniqueEnterContestantCount(true);
    }

    getUniqueRunContestantCount() {
        var contestants = this.rodeo.rodeoEvents.filter(x => x.priceTiers[0].unitPrice > 0).flatMap(x => x.schedules).flatMap(x => x.runs).flatMap(x => x.contestantOneId);
        contestants.push(...this.rodeo.rodeoEvents.filter(x => x.priceTiers[0].unitPrice > 0).flatMap(x => x.schedules).flatMap(x => x.runs).filter(x => x.contestantTwo).flatMap(x => x.contestantTwoId));
        return new Set(contestants).size;
    }

    getUniqueEnterContestantCount(lateEntered) {
        var contestants = this.rodeo.rodeoEvents.filter(x => x.priceTiers[0].unitPrice > 0).flatMap(x => x.registrations.filter(x => !lateEntered || x.created > this.rodeo.lateRegistrationStartDate)).flatMap(x => x.contestantOneId);
        contestants.push(...this.rodeo.rodeoEvents.filter(x => x.priceTiers[0].unitPrice > 0).flatMap(x => x.registrations.filter(x => !lateEntered || x.created > this.rodeo.lateRegistrationStartDate)).filter(x => x.contestantTwo).flatMap(x => x.contestantTwoId));
        return new Set(contestants).size;
    }

    getGrossIncome() : number {
        let total = this.getExhibitionSingleProfit() + this.getExhibitionBulkProfit();
        total += this.rodeo.officeFee * this.getOfficeFeeCount();
        total += this.rodeo.lateFee * this.getLateFeeCount();

        this.rodeo.rodeoEvents.forEach((rodeoEvent) => {
            total += this.getRegistrationCount(rodeoEvent, false) * rodeoEvent.priceTiers[0].unitPrice;

            rodeoEvent.sidepots.forEach((sidepot) => {
                total += this.getSidepotCount(rodeoEvent, sidepot) * sidepot.cost;
            });
        });
        return total;
    }

    getStockCosts() : number {
        return this.stockCosts.reduce((acc, cost) => { return acc + cost; }, 0);
    }

    getTotalCosts() : number {
        return this.getStockCosts() + this.calculateTotalExpenses(); 
    }

    getEntryPayout() : number {
        return this.winnerTotals.reduce((acc, winner) => { return acc + winner.main; }, 0);
    }

    getSidepotPayout() : number {
        return this.winnerTotals.reduce((acc, winner) => { return acc + winner.sidepots.reduce((acc2, winner2) => { return acc2 + winner2; }, 0) }, 0);
    }

    getTotalPayout() : number {
        return this.winnerTotals.reduce((acc, winner) => { return acc + winner.all; }, 0);
    }

    getTotalRegistrationCount() {
        let total = 0;

        this.rodeo.rodeoEvents.forEach((rodeoEvent) => {
            total += this.getRegistrationCount(rodeoEvent, false);
        });

        return total;
    }

    getTotalSidepotCount() {
        let total = 0;

        this.rodeo.rodeoEvents.forEach((rodeoEvent) => {
            rodeoEvent.sidepots.forEach((sidepot) => {
                total += this.getSidepotCount(rodeoEvent, sidepot);
            });
        });

        return total;
    }

    getTotalNotifiedTurnoutCount() { 
        let total = 0;

        this.rodeo.rodeoEvents.forEach((rodeoEvent) => {
            total += rodeoEvent.registrations.flatMap(x => x.changeRequests).filter(x => ChangeRequestHelper.isMoneyOutOfPot(x)).length;
        });

        return total;        
    }

    getEntryIncome() : number {
        let total = 0;

        this.rodeo.rodeoEvents.forEach((rodeoEvent) => {
            total += this.getRegistrationCount(rodeoEvent, false) * rodeoEvent.priceTiers[0].unitPrice;
        });

        return total;
    }

    getSidepotIncome() : number {
        let total = 0;

        this.rodeo.rodeoEvents.forEach((rodeoEvent) => {
            rodeoEvent.sidepots.forEach((sidepot) => {
                total += this.getSidepotCount(rodeoEvent, sidepot) * sidepot.cost;
            });
        });

        return total;
    }

    getSidepotProfit() {
        return this.getSidepotIncome() - this.getSidepotPayout();
    }

    getEntryProfit() {
        return this.getEntryIncome() - this.getEntryPayout() - this.getStockCosts();
    }

    getExhibitionSingleCount() {
        return this.entryCostGenerator.combinedRegistrations.flatMap(x => x.exhibitionSingleCount).reduce((acc, x) => { return acc + x; }, 0);
    }

    getExhibitionBulkCount() {
        return this.entryCostGenerator.combinedRegistrations.flatMap(x => x.exhibitionBulkCount).reduce((acc, x) => { return acc + x; }, 0);
    }

    getExhibitionSingleProfit() {
        return this.entryCostGenerator.combinedRegistrations.flatMap(x => x.exhibitionSingleCost).reduce((acc, x) => { return acc + x; }, 0);
    }

    getExhibitionBulkProfit() {
        return this.entryCostGenerator.combinedRegistrations.flatMap(x => x.exhibitionBulkCost).reduce((acc, x) => { return acc + x; }, 0);
    }

    getMemberCount() {
        return this.entryCostGenerator.combinedRegistrations.filter(x => x.membershipStatus == 'MEMBER').length;
    }

    getNonMemberCount() {
        return this.entryCostGenerator.combinedRegistrations.filter(x => x.membershipStatus == 'NON-MEMBER').length;
    }

    getProfit() {
        return this.getGrossIncome() - this.getTotalPayout() - this.getTotalCosts();
    }

    ionViewDidEnter() {
        setTimeout(() => {
            window.document.title = this.documentTitle;
            window.print();
            this.nav.pop();
        }, 0);
    }

    print() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        this.nav.push(SummaryReport, {
            rodeo: this.rodeo,
            printing: true,
            payoutPercentage: this.payoutPercentage
        }).then(() => { this.popoverActive = false; });
    }

    calculateExpenseSummaries() {
        const expenseMap = new Map<string, any>();
        const rodeoExpenseItems = this.rodeo && this.rodeo.rodeoExpenseItems ? this.rodeo.rodeoExpenseItems : [];
      
       
        let expensesFound = false;
      
        for (const item of rodeoExpenseItems) {
        
          const categoryLower = item.expenseCategory.toLowerCase();
          const descriptionLower = item.description.toLowerCase();
          const key = `${categoryLower} - ${descriptionLower}`;
      
          if (expenseMap.has(key)) {
            const existingSummary = expenseMap.get(key);
            existingSummary.count += 1;
            existingSummary.cost += parseFloat(item.amount) || 0;
            existingSummary.total = existingSummary.cost;
          } else {
        
            const newSummary = {
              category: item.expenseCategory,
              name: item.description,
              count: 1,
              cost: parseFloat(item.amount) || 0,
              total: parseFloat(item.amount) || 0,
            };
            expenseMap.set(key, newSummary);
          }

          expensesFound = true;
        }
        
        if (!expensesFound) {
          const zeroSummary = {
            category: "No Category",
            name: "No Expense",
            count: 0,
            cost: 0,
            total: 0,
          };
          expenseMap.set("nocategory-noexpense", zeroSummary);
        }
      
        this.expenseSummaries = Array.from(expenseMap.values());
        //console.log(this.expenseSummaries);
      }
      

      calculateTotalExpenses(): number {
        let totalExpenses = 0;
        this.expenseSummaries.forEach((expense) => {
          totalExpenses += expense.total;
        });
      
        return totalExpenses;
      }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-summary.ts